var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "black",
    strokeOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13281 9.49219C7.13281 8.97266 7.19727 8.55859 7.32617 8.25C7.45508 7.94141 7.70898 7.60352 8.08789 7.23633C8.4707 6.86523 8.71289 6.60156 8.81445 6.44531C8.9707 6.20703 9.04883 5.94922 9.04883 5.67188C9.04883 5.30469 8.95703 5.02539 8.77344 4.83398C8.59375 4.63867 8.32812 4.54102 7.97656 4.54102C7.64062 4.54102 7.36914 4.63672 7.16211 4.82812C6.95898 5.01562 6.85742 5.27148 6.85742 5.5957H5.43359C5.44141 4.9043 5.67578 4.35742 6.13672 3.95508C6.60156 3.55273 7.21484 3.35156 7.97656 3.35156C8.76172 3.35156 9.37305 3.55078 9.81055 3.94922C10.252 4.34766 10.4727 4.9043 10.4727 5.61914C10.4727 6.25586 10.1758 6.88281 9.58203 7.5L8.86133 8.20898C8.60352 8.50195 8.4707 8.92969 8.46289 9.49219H7.13281ZM7.0332 11.3145C7.0332 11.084 7.10547 10.8984 7.25 10.7578C7.39453 10.6133 7.58984 10.541 7.83594 10.541C8.08594 10.541 8.2832 10.6152 8.42773 10.7637C8.57227 10.9082 8.64453 11.0918 8.64453 11.3145C8.64453 11.5293 8.57422 11.709 8.43359 11.8535C8.29297 11.998 8.09375 12.0703 7.83594 12.0703C7.57812 12.0703 7.37891 11.998 7.23828 11.8535C7.10156 11.709 7.0332 11.5293 7.0332 11.3145Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.46c64856.svg";
export { ForwardRef as ReactComponent };